import React from "react";
import {
  Store,
  ShoppingCart,
  BarChart,
  Package,
  Users,
  CreditCard,
  Truck,
  Tag,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "POS Systems",
    description:
      "Build modern point-of-sale solutions with inventory and sales tracking",
    icon: CreditCard,
  },
  {
    title: "Inventory Management",
    description: "Develop real-time stock management with automated reordering",
    icon: Package,
  },
  {
    title: "Customer Loyalty Programs",
    description: "Create engagement platforms with rewards and personalization",
    icon: Users,
  },
  {
    title: "Retail Analytics",
    description:
      "Implement dashboards for sales trends, forecasting, and insights",
    icon: BarChart,
  },
  {
    title: "Omnichannel Solutions",
    description: "Integrate online and offline retail experiences seamlessly",
    icon: Store,
  },
  {
    title: "Supply Chain Integration",
    description: "Connect suppliers, warehouses, and stores efficiently",
    icon: Truck,
  },
  {
    title: "Price Optimization",
    description: "AI-driven dynamic pricing and promotion management",
    icon: Tag,
  },
  {
    title: "Staff Management",
    description: "Build scheduling, training, and performance tracking systems",
    icon: ShoppingCart,
  },
];

const STATS = [
  { value: "200+", label: "Retail Solutions" },
  { value: "10K+", label: "Stores Powered" },
  { value: "40%", label: "Efficiency Gain" },
  { value: "24/7", label: "Support" },
];

const RetailIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="retail"
      industryTitle="Retail"
      industrySubtitle="Solutions"
      heroDescription="Empowering retail businesses with innovative technology solutions for point-of-sale, inventory management, and customer engagement that drive sales and efficiency."
      themeColor="#f97316"
      themeColorLight="#fb923c"
      themeGradient="linear-gradient(135deg, #7c2d12 0%, #c2410c 50%, #f97316 100%)"
      HeroIcon={Store}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1556742504-16b083241fab?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default RetailIndustryPage;
